export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  image?: string;
  date: string;
  readTime: string;
  content: string;
  slug: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: "1",
    title: "RBAC in Node.js",
    excerpt: "Learn how TypeScript and RBAC can be used to secure your APIs.",
    date: "2025-02-20",
    readTime: "5 min",
    slug: "rbac-in-nodejs",
    content: "/markdown/rbac-in-nodejs.md",
  },
  {
    id: "2",
    title: "A React and Node.js Starter",
    excerpt: "I made a starter template with React and Node.js!",
    date: "2024-02-14",
    readTime: "5 min",
    slug: "react-node-starter",
    content: "/markdown/react-node-starter.md",
  },
  // ... other blog posts
];
